module.exports = __webpack_public_path__ + "static/007306-08308606bd2e8f544042296282f6f58f.jpg";